import React from 'react';
import { Helmet } from 'react-helmet';
import './PageNotFound.less';

export default class PageNotFound extends React.Component {
  public render() {
    return (
      <>
        <Helmet title="404" />
        <div className="common-page-not-found">Page not found.</div>
      </>
    );
  }
}
